<template>
  <form @submit.prevent="handleSubmit">
    <div class="twostepform">
      <p class="title">{{ $t("components.jouw_account") }}</p>
      <p class="number" v-html="loggingIn"></p>
      <p></p>
      <div class="form-group">
        <label for="number">{{ $t("components.inlog_code") }}</label>
        <input
          @click="submitOnEnter"
          type="text"
          id="number"
          key="number-input"
          v-model="number"
          name="number"
          class="form-control"
          :class="{ 'is-invalid': switchForm && errors.has('number') }"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
        <!-- display feedback if input is invalid -->
        <div v-if="switchForm && errors.has('number')" class="invalid-feedback">
          {{ errors.first("number") }}
        </div>
      </div>
      <div class="wrappercheckbox">
        <input
          class="checkbox"
          type="checkbox"
          name="remember"
          id="remember"
          value="1"
        />
        <label for="remember">{{ $t("components.onthoud_apparaat") }}</label>
      </div>
      <button id="btn-2" class="btn2" type="submit">
        <div>Log in</div>
        <img src="../../assets/Icons/arrow-white.svg" alt="arrow" />
      </button>
    </div>
    <div class="linkstwostep">
      <p class="bodytwostep">{{ $t("components.geen_bericht") }}</p>
      <p class="bodytwostep" @click="resendCode">
        {{ $t("components.opnieuw") }}
      </p>
    </div>
  </form>
</template>

<script>
// import { mapState } from "vuex";
// export default {
//   data() {
//     return {
//       number: "",
//       switchForm: false,
//     };
//   },
//   methods: {
//     resendCode() {
//       this.$emit("resendCode");
//     },
//     submitOnEnter() {
//       let input = document.getElementById("number");
//       input.addEventListener("keyup", function (event) {
//         if (event.keyCode === 13) {
//           event.preventDefault();
//           document.getElementById("btn-2").click();
//         }
//       });
//     },
//     validationSet() {
//       const rules = {
//         number: {
//           rule: {
//             required: true,
//             numeric: true,
//             min: 6,
//           },
//           value: this.number,
//         },
//       };

//       return rules;
//     },
//     handleSubmit() {
//       this.switchForm = true;

//       if (this.validation(this.validationSet())) {
//         this.$emit("login", this.number);
//       }
//     },
//   },
//   computed: {
//     ...mapState("auth", ["loggingIn"]),
//   },
// };

import { ref, onMounted, getCurrentInstance, computed } from "vue";
import { useStore } from "vuex";

export default {
  setup(props, { emit }) {
    // Use Vuex store
    const store = useStore();

    // Define reactive data
    const number = ref("");
    const switchForm = ref(false);

    // Access Global Validation
    const instance = getCurrentInstance();
    const validation = instance.appContext.config.globalProperties.validation;

    // Define methods
    const resendCode = () => {
      emit("resendCode");
    };

    const submitOnEnter = () => {
      const input = document.getElementById("number");
      input.addEventListener("keyup", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          document.getElementById("btn-2").click();
        }
      });
    };

    const validationSet = () => {
      const rules = {
        number: {
          rule: {
            required: true,
            numeric: true,
            min: 6,
          },
          value: number.value,
        },
      };

      return rules;
    };

    const handleSubmit = () => {
      switchForm.value = true;

      if (validation(validationSet())) {
        emit("login", number.value);
      }
    };

    // Get computed state from Vuex store
    const loggingIn = computed(() => store.state.auth.loggingIn);

    // Mounting lifecycle hook
    onMounted(() => {
      submitOnEnter();
    });

    // Return reactive data and methods
    return {
      number,
      switchForm,
      resendCode,
      submitOnEnter,
      validationSet,
      handleSubmit,
      loggingIn,
    };
  },
};
</script>

<style lang="sass" scoped>
.twostepform
  .title
    height: 45px
    color: $black
    font-size: 28px
    font-weight: 300
    margin-top: 0
    padding-top: 10px
    text-align: center
  .number
    margin: 0
    margin-bottom: 30px
    line-height: 25px
    font-size: 15px
    word-break: break-all
    -moz-appearance: textfield
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0
  .form-group
    &:focus-within
      color: #104E8A
    .form-control
      width: 100%
      padding: 11px 0px
      border: none
      border-bottom: 1px solid $black
      margin-bottom: 2px
      display: flex
      box-sizing: border-box
      font-size: 15px
      line-height: 24px
      font-family: Ubuntu
      &:focus
        color: #104E8A
        border-bottom: 1px solid #104E8A
        outline: none
    .is-invalid
      border-bottom: 1px solid $red
    .invalid-feedback
      color: $red
      font-size: 0.8em
  .wrappercheckbox
    margin-bottom: 35px
    margin-top: 15px
    input[type="checkbox"]
      display: none
      + label
        display: inline
        font-size: 15px
        position: relative
        &::before
          display: inline-block
          width: 18px
          height: 18px
          content: ' '
          border: 2px solid $black
          border-radius: 4px
          vertical-align: middle
          margin-top: -2px
          margin-right: 15px
          cursor: pointer
          z-index: 10
      &:checked + label
        &::before
          border: 2px solid $black
          background-color: $black
        &::after
          width: 4px
          height: 8px
          border: 3px solid $white
          position: absolute
          border-left: none
          border-top: none
          content: ' '
          left: 8px
          bottom: 4px
          transform: rotatez(45deg)
          cursor: pointer
          z-index: 20
  .btn2
    width: 100%
    height: 45px
    display: flex
    align-items: center
    font-weight: 500
    font-size: 15px
    border: none
    line-height: 25px
    border-radius: 22.5px
    background-color: $red
    color: $white
    transition: background-color 300ms ease
    &:hover
      background-color: #CA3233
    div
      width: 94%
      padding-left: 10px
      margin-right: -25px
.linkstwostep
  .bodytwostep
    display: flex
    justify-content: center
    font-size: 15px
    &:last-child
      text-decoration: none
      color: $black
      font-weight: 500
      &:hover
        cursor: pointer
</style>
